import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { searchOrderHistory } from '../../../api/orderHistory'
import { raiseToast } from '../toast/toast'


export const fetchOrderHistory = createAsyncThunk('orderHistory/searchOrderHistory', async (params, { dispatch }) => {
    const response = await searchOrderHistory(params)
    
    if(response.failure){
        dispatch(raiseToast({severity:'error', summary: response.data.error, detail: 'Invalid text',  life: 3000}))
        throw Error()
    }
    return response.data
})


export const orderHistorySlice = createSlice({
    name : "orderHistory/searchOrderHistory",
    initialState : {
        loading: false,
        orderHistoryList: [],
        paginationParams: {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true
        },
        searchParams: {
            dataType: "orderHistoryData",
            searchBy: "all",
            searchText: "",
            statusId: 1,
            dateType: "createdAt"
        },
        searchOptions: []
    },
    reducers: {
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
        },
        updateBuyerInvoiceData: (state, action) => {
            state.orderHistoryList = action.payload
        }
    },
    extraReducers : (builder) => {
        builder.addCase(
            fetchOrderHistory.fulfilled, (state, action) => {
                state.loading = false 
                state.orderHistoryList = action.payload.data
                state.paginationParams.pageNo = action.payload?.pageNo - 1
                state.paginationParams.recordsPerPage = action.payload?.recordsPerPage 
                if(action.payload?.totalRecords || action.payload?.totalRecords === 0){
                    state.paginationParams.totalRecords =  action.payload?.totalRecords
                    state.paginationParams.excessPagesFound = false
                }
                if(action.payload.excessPagesFound || !action.payload.excessPagesFound){
                    if(!state.paginationParams.excessPagesFound){
                        state.paginationParams.excessPagesFound = action.payload.excessPagesFound
                    }else if(action.payload.excessPagesFound === false){
                        state.paginationParams.excessPagesFound = false
                    }
                }
            }
        )
        .addCase(
            fetchOrderHistory.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchOrderHistory.rejected, (state, action) => {
                state.loading = false
            }
        )
    }

})

export const { updateSearchParams, updateSearchOptions } = orderHistorySlice.actions

export default orderHistorySlice.reducer